<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">

                    <div class="vx-row no-gutter justify-center items-center">

                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login-bg.jpeg" alt="login" class="mx-auto">
                        </div>

                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="px-8 pt-8 login-tabs-container">

                                <div class="vx-card__title mb-4">
                                    <h4 class="mb-4">Login</h4>
                                    <p>Witamy ponownie! Zaloguj się do Twojego konta</p>
                                </div>

                                <div class="vx-col mb-4 mt-20">
                                    <login-jwt></login-jwt>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>


<script>
import LoginJwt from './LoginJWT.vue'

export default {
    components: {
        LoginJwt
    },
    mounted() {
        if (this.$route.params.code) {
            let requestObject = {
                url: process.env.VUE_APP_API_ENDPOINT + '/v1/auth/confirm',
                method: 'post',
                data: {
                    code: this.$route.params.code
                }
            };

            this.$http.request(requestObject).then(response => {
                if (response.data.data.flag === true) {
                    this.$vs.dialog({
                        color: 'success',
                        title: `Wiadomość`,
                        text: 'Twoje konto zostało aktywowane',
                        accept: this.acceptAlert
                    })
                } else {
                    this.$vs.dialog({
                        color: 'warning',
                        title: `Błąd`,
                        text: 'Wystąpił błąd podczas aktywacji. Spróbuj ponownie lub skontaktuj się z administratore,',
                        accept: this.acceptAlert
                    })
                }
            });
        } else {
            console.log('nocode');
        }
    }
}
</script>

<style lang="scss">
.login-tabs-container {
    min-height: 505px;

    .con-tab {
        padding-bottom: 14px;
    }

    .con-slot-tabs {
        margin-top: 1rem;
    }
}
</style>
